import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import axios from "axios";

const app = createApp(App);

app.use(Quasar, quasarUserOptions);
app.use(router);

// http client ke drkevin-scan-backend (baseURL dari .env VUE_APP_BASE_URL)
app.provide(
  "$http",
  axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
  }),
);

app.mount("#app");
